import { Outlet } from "react-router-dom";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { NavigationPane } from "../../components/organisms";

const AppLayout = () => {

    return (        
        <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={12}>
                <div className="app-header">                                
                    <NavigationPane /> 
                </div>
            </Grid>
            <Grid item xs={12}>                
                <Container maxWidth="xl" sx={{ minHeight: '100vh', maxHeight: "fit-content", margin: "20px auto" }}>
                    <Outlet/>
                </Container>                 
            </Grid>            
        </Grid>
    );

}

export default AppLayout;